/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChangeUserRolePayload = {
    role: ChangeUserRolePayload.role;
};
export namespace ChangeUserRolePayload {
    export enum role {
        OWNER = 'owner',
        ADMIN = 'admin',
        PRACTITIONER = 'practitioner',
        ASSISTANT = 'assistant',
        VIEWER = 'viewer',
        THERAPIST = 'therapist',
        USER = 'user',
    }
}

